import axios from 'axios'
import AuthResponse from '../models/responses/AuthResponse'
import APIRequestError from '../models/responses/APIRequestError'
import Member from '../models/entities/Member'
import APIResponseError from '../models/responses/APIResponseError'
import PreferencesResponse from '../models/responses/PreferencesResponse'
import ProfileResponse from '../models/responses/ProfileResponse'
import OfferResponse from '../models/responses/OfferResponse'
import OfferDetailResponse from '../models/responses/OfferDetailResponse'
import CardResponse from '../models/responses/CardResponse'
import LinkCardResponse from '../models/responses/LinkCardResponse'
import UnlinkCardResponse from '../models/responses/UnlinkCardResponse'
import RewardCountResponse from '../models/responses/RewardCountResponse'
import FuelDiscountBalanceResponse from '../models/responses/FuelDiscountBalanceResponse'
import RewardsInProgressResponse from '../models/responses/RewardsInProgressResponse'
import TransactionHistoryResponse from '../models/responses/TransactionHistoryResponse'
import injector from 'vue-inject'
import moment from 'moment'
import 'es6-promise/auto'
import SecurityCodeResponse from '../models/responses/SecurityCodeResponse'

export default class ExcentusAPIService {
    constructor () {
        // this._stagingAuthHeader = 'Basic NThmNGRkMWMtZmFjZi00NzIwLWI3ZDktNDI4Mjk1ZmM3OWMyOmIxM2VkOWNkLTA1ZjktNGRkYi05MGJkLTRkMWFlODhiMTljZA=='
        this._authHeader = 'Basic ZmVmNjFmY2UtOGU0ZS00MDBkLWIxOTgtZDgzZmFmNmJkZjBiOjgxNTk0NWU4LWIzNGMtNGQ3Ny05NTFhLWQwMGNkZGMxNjE2OQ=='
        // this._stagingBaseAuthUrl = 'http://staging-auth.api.bellstores.innismaggiore.org/authservice/v2'
        this._baseAuthUrl = 'https://auth.api.bellstores.com/authservice/v2'
        this._authObj = undefined
        // this._stagingBaseUrl = 'http://staging-api.bellstores.innismaggiore.org/fuelrewards/public/rest/v2/bellstores'
        this._baseUrl = 'https://api.bellstores.com/fuelrewards/public/rest/v2/bellstores'
        this._member = undefined
        this._storageService = injector.get('storageService')
        this._retailerId = 'CR1001'
        axios.defaults.headers.common.Authorization = this._authHeader
    }

    isAuthenticated () {
        if (this._authObj === undefined && this._storageService.getByKey('auth') !== undefined) {
            const storedAuth = this._storageService.getByKey('auth')
            this._authObj = new AuthResponse(storedAuth)
        }

        return this._authObj !== undefined && !this._authObj.isExpired()
    }

    async auth () {
        console.log('Reauthenticating...')
        const url = this._baseAuthUrl + '/accesstokens'
        const that = this
        const options = {
            url: url,
            method: 'post',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: 'grant_type=client_credentials',
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                console.log(json)
                const authResponse = new AuthResponse(json)
                if (authResponse.success()) {
                    that._authObj = authResponse
                    that._storageService.setByKey('auth', authResponse.toStore())
                }
                return authResponse
            })
            .catch(function (error) {
                return new APIRequestError(error.data)
            })
    }

    async loginMember (userId, password) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const url = this._baseUrl + '/login'
        const options = {
            url: url,
            method: 'post',
            headers: {
                access_token: this._authObj.accessToken(),
                'content-type': 'application/json'
            },
            data: { userId: userId, password: password },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors !== undefined) {
                    return new APIResponseError(json)
                } else {
                    return new Member(json)
                }
            })
            .catch(function (error) {
                return new APIRequestError(error.data)
            })
    }

    async registerMember (member) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        member.partnerAttributes = {
            participantId: 'CR1001',
            partnerAssociation: 'bellstoresappbc',
            name: 'bellstores',
            value: 'tag'
        }

        const url = this._baseUrl + '/members'
        const options = {
            url: url,
            method: 'post',
            headers: {
                access_token: this._authObj.accessToken(),
                'content-type': 'application/json'
            },
            data: member,
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors !== undefined) {
                    return new APIResponseError(json)
                } else {
                    return new Member(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async getPreferences () {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember()
        if (member === undefined && !(member instanceof Member)) {
            throw new Error('Must have a member')
        }

        const accountNumber = member.getProperty('accountNumber')
        const url = `${this._baseUrl}/members/${accountNumber}/preferences`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new PreferencesResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async getProfile () {
        const member = await this.getMember()
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}?memberAttributes=Y`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new ProfileResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async updateProfile (profileDetails) {
        const member = await this.getMember()
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}`

        // This field is not in the docks, which might cause issues?
        if ('emailVerified' in profileDetails) {
            delete profileDetails.emailVerified
        }

        // This field will result in a "Bad Data format" error.
        if ('memberEligibilityVerification' in profileDetails) {
            delete profileDetails.memberEligibilityVerification
        }

        const options = {
            url: url,
            method: 'put',
            headers: {
                'content-type': 'application/json',
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true,
            data: profileDetails
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new ProfileResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async getOffers (pageNumber) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const pageSize = 12
        const url = this._baseUrl + `/retailer/offers?retailerUdk=${this._retailerId}&offerType=DPC,EBO,NBKT,NMVB,NPROD,NSVB&pageSize=${pageSize}&pageNumber=${pageNumber}`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new OfferResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async rewardsInProgress () {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember()
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}/rewardsInProgress`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken(),
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new RewardsInProgressResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async transactionHistory (pageNumber) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const pageSize = 15
        const member = await this.getMember()
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}/txnhistory?pageNumber=${pageNumber}&pageSize=${pageSize}&transactionType=Redemption`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken(),
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new TransactionHistoryResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async refreshMemberToken () {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember(true)
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}/token`
        const options = {
            url: url,
            method: 'post',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true,
            data: {
                memberRefreshToken: member.getProperty('memberRefreshToken')
            }
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    throw new Error('Failed to refresh token')
                } else {
                    return json
                }
            })
            .catch(function (err) {
                console.error('Failed to refresh token: ' + err.data)
            })
    }

    async getOfferDetail (offerId) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const url = this._baseUrl + `/offers/${offerId}?siteId=FUEL`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new OfferDetailResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async getCards () {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember(true)
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}/cards`
        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new CardResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async linkCard (cardNumber) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember()
        const profile = await this.getProfile()
        const address = profile.getProperty('address')
        const url = this._baseUrl + '/members/cardlink'

        const options = {
            url: url,
            method: 'post',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true,
            data: {
                accountNumber: member.getProperty('accountNumber'),
                retailerId: this._retailerId,
                cardNumber: cardNumber,
                lastName: member.getProperty('lastName'),
                zipCode: address.zipCode
            }
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new LinkCardResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async unlinkCard (cardNumber) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember()
        const url = this._baseUrl + '/members/cardunlink'

        const options = {
            url: url,
            method: 'post',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true,
            data: {
                accountNumber: member.getProperty('accountNumber'),
                retailerId: this._retailerId,
                cardNumber: cardNumber
            }
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new UnlinkCardResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async rewardCount () {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember()
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}/rewardsInProgress?earnFlag=Y`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken(),
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new RewardCountResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async fuelDiscountBalance () {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const member = await this.getMember()
        const url = this._baseUrl + `/members/${member.getProperty('accountNumber')}/balances`

        const options = {
            url: url,
            method: 'get',
            headers: {
                'content-type': 'application/json',
                memberAccessToken: member.getProperty('memberAccessToken')
            },
            json: true
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new FuelDiscountBalanceResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async forgotPassword (userId) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const url = this._baseUrl + '/members/password/securitycode'
        const options = {
            url: url,
            method: 'post',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true,
            data: {
                userId: userId,
                channel: 'email'
            }
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new SecurityCodeResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async validateCode (userId, uniqueCode) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const url = this._baseUrl + '/members/password/uniquecode/validate'
        const options = {
            url: url,
            method: 'post',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true,
            data: {
                userId: userId,
                uniqueCode: uniqueCode
            }
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new SecurityCodeResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async changePassword (userId, securityCode, password) {
        if (!this.isAuthenticated()) {
            throw new Error('Must be authenticated to make this request')
        }

        const url = this._baseUrl + '/members/password'
        const options = {
            url: url,
            method: 'put',
            headers: {
                'content-type': 'application/json',
                access_token: this._authObj.accessToken()
            },
            json: true,
            data: {
                userId: userId,
                securityCode: securityCode,
                password: password
            }
        }

        return axios(options)
            .then(function (response) {
                const json = response.data
                if (json.errors) {
                    return new APIResponseError(json)
                } else {
                    return new SecurityCodeResponse(json)
                }
            })
            .catch(function (err) {
                return new APIRequestError(err.data)
            })
    }

    async getMember (dontRefresh) {
        const memberJSON = this._storageService.getByKey('member')
        const member = Member.fromStore(memberJSON)

        if (member.isExpired() && !dontRefresh) {
            console.log('refreshing member token')
            // refresh here
            const refreshed = await this.refreshMemberToken()
            member.setProperty('memberAccessToken', refreshed.token.memberAccessToken)
            member.setProperty('memberRefreshToken', refreshed.token.memberRefreshToken)
            member.setProperty('expiresIn', moment().add(refreshed.token.ttl, 'seconds'))
            this._storageService.setByKey('member', member.toStore())
        }

        return member
    }
}



// WEBPACK FOOTER //
// ./src/services/ExcentusAPIService.js